module.exports = __webpack_public_path__ + "img/2021_1.b7038a44.jpg";